/* global Event, location */

import Cookies from 'js-cookie'

class CCookieBanner {
  constructor () {
    this.popupHrefTrigger = '#cookie-settings-overlay'
  }

  init () {
    if (!this.banner) {
      return
    }
    this.addListeners()
  }

  /**
     * Check if anchor wants to trigger an action e.g. open popup.
     * @param hash
     * @param e
     */
  callHashTriggers (hash, e) {
    if (this.isPopupHrefTrigger(hash)) {
      __cmp('showScreen');
      e.preventDefault()
    }
  }

  /**
     * Add required listeners.
     */
  addListeners () {
    this.hrefListener()
  }

  /**
     * Forwards every anchor href to callHashTriggers().
     */
  hrefListener () {
    let anchors = document.getElementsByTagName('a')
    if (!anchors.length) {
      return
    }

    anchors = Array.prototype.slice.call(anchors)
    anchors.forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        this.callHashTriggers(anchor.getAttribute('href'), e)
      })
    })
  }

  /**
     * Check if toggle popup action.
     * @param hash
     * @returns {boolean}
     */
  isPopupHrefTrigger (hash) {
    return hash === this.popupHrefTrigger
  }
}

const CookieBanner = new CCookieBanner()
CookieBanner.init()
